import { Box, Link } from '@mui/material';
import { ReactComponent as Logo } from 'assets/svg/logo.svg';
import { ReactComponent as MacOsLogo } from 'assets/svg/mac-os-logo.svg';
import BaseTypography from 'components/typography/BaseTypography';
import { footerConfig, footerRightSectionConfig } from 'config/footerConfig';
import { FooterLinks } from 'constants/enums/FooterLinks.ts';
import { sectionStyles } from 'layouts/pages/landing-page/components/sections/sectionStyles';
import React from 'react';
import { colorPalette } from 'ui-blocks/ColorPalette';
import { reusableStyles } from 'ui-blocks/ReusableStyles';

export function Footer() {
	return (
		<Box id="footer" sx={{ ...sectionStyles.footerStyle }}>
			<Box id="left-section" sx={{ ...reusableStyles.flexColWithGap(16) }}>
				<Logo style={{ color: colorPalette.text_medium }} />
				<Box id="logos" sx={{ ...sectionStyles.footerLogoStyle }}>
					{footerConfig.map((footer) => (
						<Link
							key={footer.name}
							href={footer.url}
							id={`${footer.name}-icon`}
							target="_blank"
							rel="noopener noreferrer"
						>
							{footer.icon}
						</Link>
					))}
				</Box>
			</Box>

			<Box
				id="right-section"
				sx={{
					display: 'flex',
					flexDirection: { xs: 'column', sm: 'row' },
					gap: '34px',
					color: 'colors.light7',
				}}
			>
				<Box id="MacOs link">
					<Box sx={{ marginBottom: '8px', color: 'colors.light6' }}>
						<BaseTypography variant="t2_zodiak_medium">For advanced users</BaseTypography>
					</Box>
					<Link href={FooterLinks.MAC_OS_LINK} target="_blank" rel="noopener noreferrer">
						<MacOsLogo />
					</Link>
				</Box>
				<Box sx={{ ...reusableStyles.flexRowWithGap(34), alignItems: 'start' }}>
					{footerRightSectionConfig.map((footerRightSection) => (
						<Box key={footerRightSection.header} id="right-sub-section">
							<Box sx={{ marginBottom: '8px', color: 'colors.light6' }}>
								<BaseTypography variant="t2_zodiak_medium">
									{footerRightSection.header}
								</BaseTypography>
							</Box>
							{footerRightSection.links.map((link) => (
								<Link
									key={link.name}
									href={link.url}
									target="_blank"
									rel="noopener noreferrer"
									sx={{
										color: 'colors.light7',
										textDecoration: 'none',
										'&:hover': {
											color: 'colors.light6',
										},
									}}
								>
									<BaseTypography variant="b2_v4_regular">{link.name}</BaseTypography>
								</Link>
							))}
						</Box>
					))}
				</Box>
			</Box>
		</Box>
	);
}
